
import { useState } from 'react';
import Hero from './components/Hero';
import Subsidiaries from './components/Subsidiaries';
import Mission from './components/Mission';
import News from './components/News';
import Calendar from './components/Calendar';
import Contact from './components/Contact';
import Footer from './components/Footer';

export default function HomePage() {
  return (
    <div className="min-h-screen bg-[#F5E6D3]">
      <Hero />
      <Mission />
      <Subsidiaries />
      <News />
      <Calendar />
      <Contact />
      <Footer />
    </div>
  );
}
